'use strict';

var keys = Object.keys;

module.exports = function (object) {
	return keys(object == null ? object : Object(object));
};



/*****************
 ** WEBPACK FOOTER
 ** /Users/gaearon/p/react-devtools/~/es5-ext/object/keys/shim.js
 ** module id = 17
 ** module chunks = 0
 **/